import { 
  wishlistCountResource
} from '@services/wishlists.service'

export function createStore() {
  return {
    namespaced: true,

    state: {
      count: 0,
    },

    actions: {
      async getWishlistCount({ commit }) {
        const { data } = await wishlistCountResource.execute();
        commit('SET_COUNT', data.item.count);
      },

      updateWishlistCount({ commit, state }, { liked }) {
        const delta = liked ? 1 : -1;
        commit('SET_COUNT', state.count + delta);
      },
    },

    mutations: {
      SET_COUNT(state, value) {
        state.count = value < 0 ? 0 : value;
      },
    },
  }
}
